import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { pathNames } from '@/shared/utils/constants'

export const callQueuesBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { useQueueServiceStore } = await import('@/entities/queue-service')
  const store = useQueueServiceStore()
  await store.fetchAll()

  if (!store.hasQueues) {
    next({ name: pathNames.MAIN })
    return
  }

  next()
}
